 
function customerColumns(handleEdit, handleDelete) {
  return [
    {
      Header: "Vehicle No",
      accessor: "vehicle_no",
      disableFilters: true,
      filterable: false,
    },
    {
      Header: "Phone",
      accessor: "phone",
      disableFilters: true,
      filterable: false,
    },
    {
      Header: "Email",
      accessor: "email",
      disableFilters: true,
      filterable: false,
      Cell: ({ value }) => <span>{value ? value : "-"}</span>,
    },
    {
      Header: "Status",
      accessor: "status",
      disableFilters: true,
      filterable: false,
      Cell: ({ value }) => (
        <span className={`badge ${value ? "bg-success" : "bg-warning"}`}>
          {value ? "Active" : "Inactive"}
        </span>
      ),
    },
    {
      Header: "Actions",
      accessor: "actions",
      disableFilters: true,
      filterable: false,
      Cell: ({ row }) => (
        <div className="d-flex gap-2">
          {handleEdit && (
            <button
              onClick={() => handleEdit(row.original)}
              className="btn btn-sm btn-primary"
            >
              Edit
            </button>
          )}
          {handleDelete && (
            <button
              onClick={() => handleDelete(row.original)}
              className="btn btn-sm btn-danger"
            >
              Delete
            </button>
          )}
        </div>
      ),
    },
  ];
}

export default customerColumns;
